module.exports = __webpack_public_path__ + "img/mail.12495e22.svg";